module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioBtn.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./radioBtn.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/radioBtn.vue
 ** module id = 130
 ** module chunks = 0
 **/